<template>
  <div>
    <AlertLayout
      title="Reminders!"
      message="<ul>Kindly remember to inform the donor why they have been deferred.</ul>
      <ul>Kindly remember to inform the donor that they are free to donate once the deferral period is over</ul>
      <ul>Kindly thank the donor for turning up to donate</ul>"
      type="warning"
    />
    <div class="mx-auto p-10 border border-t-0">
      <h2 class="text-lg font-bold mb-6">Add New Deferral</h2>

      <!-- New Deferral Form -->
      <form class="grid grid-cols-1 gap-5">
        <div class="flex items-center space-x-2">
          <input
            v-model="deferralForm.is_indefinite"
            type="checkbox"
            id="isIndefinite"
            class="w-4 h-4 text-custom-yellow border-gray-300 rounded focus:ring-custom-yellow"
          />
          <label class="text-sm font-medium text-gray-700" for="isIndefinite"
            >Indefinite deferral (no timeline)</label
          >
        </div>

        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <div :class="deferralForm.is_indefinite ? 'opacity-50 pointer-events-none' : ''">
            <label class="block mb-1" for="deferralDays">Deferral Days</label>
            <input
              v-model.number="deferralForm.deferral_days"
              type="text"
              id="deferralDays"
              class="w-full p-2 border rounded bg-gray-100 placeholder-gray-400 shadow-sm shadow-gray-300"
              :disabled="deferralForm.is_indefinite"
              :required="!deferralForm.is_indefinite"
            />
          </div>
          <div :class="deferralForm.is_indefinite ? 'opacity-50 pointer-events-none' : ''">
            <label class="block mb-1" for="deferralHours">Deferral Hours</label>
            <input
              v-model.number="deferralForm.deferral_hours"
              type="text"
              id="deferralHours"
              class="w-full p-2 border rounded bg-gray-100 placeholder-gray-400 shadow-sm shadow-gray-300"
              :disabled="deferralForm.is_indefinite"
              :required="!deferralForm.is_indefinite"
            />
          </div>
        </div>

        <div>
          <label class="block mb-1" for="deferralReason"
            >Reason for Deferral <span class="text-red-500">*</span></label
          >
          <textarea
            v-model="deferralForm.deferral_reason"
            id="deferralReason"
            rows="4"
            class="w-full p-2 border rounded bg-gray-100 placeholder-gray-400 shadow-sm shadow-gray-300"
            required
          ></textarea>
        </div>
        <div class="flex justify-end space-x-2">
          <button
            @click="resetForm"
            class="px-4 py-2 border rounded text-orange-500 border-orange-500"
          >
            Cancel
          </button>
          <CustomButton
            label="Submit"
            bg-class="bg-custom-yellow px-8 py-3"
            @click="submitDeferralForm"
          />
        </div>
      </form>
      <!-- End New Deferral Form -->
    </div>
  </div>
</template>

<script>
import AlertLayout from "@/components/AlertLayout.vue";
import CustomButton from "@/components/CustomButton.vue";
import api from "@/services/api";
import SweetAlertService from "@/services/SweetAlertService";

export default {
  name: "NewDonorDeferralForm",
  components: {
    AlertLayout,
    CustomButton,
  },
  data() {
    return {
      donor: null,
      error: null,
      showDeferralPopup: false,
      deferralForm: {
        deferral_days: "",
        deferral_hours: "",
        deferral_reason: "",
        is_indefinite: false,
      },
    };
  },

  methods: {
    user() {
      return this.$store.getters["auth/user"];
    },

    async submitDeferralForm() {
      // Check for empty fields
      const emptyFields = [];
      if (!this.deferralForm.deferral_reason)
        emptyFields.push("Reason for Deferral");

      // If any required fields are empty, show an alert and stop the submission
      if (emptyFields.length > 0) {
        SweetAlertService.showEmptyFieldsAlert(emptyFields);
        return;
      }

      try {
        const donorId = this.$route.params.donor_id;

        const payload = {
          donor_deferral: {
            deferral_days: this.deferralForm.is_indefinite
              ? null
              : this.deferralForm.deferral_days,
            deferral_hours: this.deferralForm.is_indefinite
              ? null
              : this.deferralForm.deferral_hours,
            deferral_reason: this.deferralForm.deferral_reason,
            is_indefinite: this.deferralForm.is_indefinite,
            added_by: this.user().user_id,
          },
        };

        // Make API call to create deferral
        await api.createDonorDeferral(donorId, payload);

        // Show success alert
        await SweetAlertService.showSuccess(
          "Success",
          "Deferral added successfully!.",
        );

        this.resetForm();
        this.$router.push({ name: "DonorDetailsPage" });
      } catch (error) {
        console.error("Error creating deferral:", error);

        // Show error alert
        SweetAlertService.showError(
          "Error",
          "Failed to create deferral. Please try again.",
        );
      }
    },

    resetForm() {
      this.deferralForm = {
        deferral_days: "",
        deferral_hours: "",
        deferral_reason: "",
        is_indefinite: false,
        added_by: this.user().user_id,
        facility_id: this.user().facility_id,
      };
    },
  },
};
</script>

<style lang="css" scoped>
/* Your existing styles */
</style>
